<!--
 * @Author: chenmengnan
 * @Date:  2024-12-17 11:23:45
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2025-01-22 10:17:41
 * @Description: 数据管理
 * @FilePath: \web\src\components\DataManagement\userExamine\refuseExamine.vue
-->
<template>
  <div class="role-management-wrap">

    <div class="role-management-main">
      <div class="search-container">

        <div class="search">
          <div class="search-item">
            <div class="search-item-text">用户名：</div>
            <a-input class="user-name-input" v-model:value="requestParams.username" />
          </div>
          <div class="search-item">
            <div class="search-item-text">联系方式：</div>
            <a-input class="user-name-input" v-model:value="requestParams.phone" />
          </div>
          <div class="search-item">
            <div class="search-item-text">邮箱：</div>
            <a-input class="user-name-input" v-model:value="requestParams.email" />
          </div>
          <div class="search-item">
            <div class="search-item-text">姓名：</div>
            <a-input class="user-name-input" v-model:value="requestParams.name" />
          </div>
          <!-- 组织机构 -->
          <div class="btn-wrapper">
            <div class="reset-btn btn-item" @click="resetSearch">重置</div>
            <div class="search-btn btn-item" @click="submitSearch()">查询</div>
          </div>
        </div>
        <div class="crud-wrapper">
          <div class="crud-item crud-item-abled" @click="selectDownload()">
            导出
          </div>
        </div>
      </div>

      <a-table rowKey="id" class="management-table" :dataSource="userList" :loading="userPagesLoading"
        :columns="columns" @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
        <template #serial="{ index }">{{ index + 1 }}</template>


      </a-table>


      <!-- / 操作弹出框 -->
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onBeforeMount, computed } from 'vue';
import { getLsitPageApi, userCheckDownApi } from '@/api/dataManagement/examineManagement.js';
import { downLoadUtil } from '@/components/utils/utils';

import { tableConfigRefuse } from './tableConfig.js';
import { message } from 'ant-design-vue';

const columns = tableConfigRefuse;
const userList = ref([])


const requestParams = reactive({
  name: null,
  email: null,
  phone: null,
  username: null,
  status: 3,
  page: 1,
  size: 8,
  // 升序降序
  order: 'asc',
})
const totalCount = ref(0)
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.size,
  current: requestParams.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['8', '10', '20', '30', '40', '50',],
}));

/**
 * 获取列表
 */
const getTableList = () => {
  getLsitPageApi(requestParams).then((res) => {
    console.log(res, 'getTableList')
    if (res.status === 200) {
      userList.value = res.data.list
      totalCount.value = res.data.totalCount
    }
  }).catch(() => {
    message.error('请求失败，请检查网络')
  });
}
/**
 * @description 检索查询
 */
const submitSearch = () => {
  requestParams.page = 1;
  requestParams.size = 8;
  getTableList()
};
/**
 * 导出
 */
const selectDownload = () => {
  requestParams
  userCheckDownApi(requestParams).then((res) => {
    downLoadUtil(res).then(() => { });
    confirmModalConf.visible = false;
  });
}
/**
 * @description 检索重置事件
 */
const resetSearch = () => {
  requestParams.name = null;
  requestParams.email = null;
  requestParams.phone = null;
  requestParams.username = null;
  requestParams.page = 1
  requestParams.size = 8
  submitSearch();
};


/**
 * @description 页码change事件
 */
const changePage = (page) => {
  requestParams.page = page.current;
  requestParams.size = page.pageSize;
  getTableList();
};

onBeforeMount(() => {

  submitSearch();
});

</script>

<style lang="scss">
.role-management-wrap {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: rgba(179, 150, 92, 0.05);

  .role-management-main {
    height: 100%;
    width: 100%;
    background: rgba(179, 150, 92, 0.05);

    /* 检索条件 */
    .search-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: .1rem;
      height: 0.5rem;
      margin-bottom: 0.1rem;

      .search {
        display: flex;

        .search-item {
          width: 2.2rem;
          height: 0.34rem;
          margin-right: 0.05rem;
          display: flex;

          .search-item-text {
            color: #fff;
            width: 1.1rem;
            text-align: right;
            height: 0.34rem;
            line-height: 0.34rem;
          }
        }

        /* 重置、查询操作 */
        .btn-wrapper {
          height: 0.32rem;
          line-height: 0.32rem;
          margin-left: 0.2rem;
          color: #ffffff;
          display: flex;
          padding: 0;

          .btn-item {
            width: 0.9rem;
            text-align: center;
            cursor: pointer;

            &:active {
              opacity: 0.8;
            }
          }

          .reset-btn {
            // background-color: #535962;
            background-image: url(~@/static/images/dataManagement/reset_btn.png);
            background-size: 100% 100%;
          }

          .search-btn {
            margin-left: 0.05rem;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/submit_btn.png);
            background-size: 100% 100%;
          }
        }

        /* 输入框 */
        .ant-input {
          color: white;
          background-color: rgba(91, 76, 39, 0.4);
          font-size: 0.14rem;
          font-family: Microsoft YaHei;
          border: transparent;
        }

        .ant-input-suffix {
          width: 0.12rem;
          height: 0.12rem;
          margin-top: .02rem;
        }

        /** 下拉框 */
        .ant-select {
          width: 100%;
          height: 100%;

          .ant-select-selector {
            height: 100%;
          }

          .ant-select-arrow {
            color: #fff;
          }

          .ant-select-selection-item {
            line-height: .34rem;
          }

          // 背景
          &:not(.ant-select-customize-input) .ant-select-selector {
            background-color: rgba(91, 76, 39, 0.4);
            border: none;
            color: #fff;
          }

          /* 描述 */
          .ant-select-selection-placeholder {
            line-height: .34rem;
            color: #fff;
          }
        }
      }

      /* 增删改导按钮 */
      .crud-wrapper {
        display: flex;
        height: 0.51rem;
        padding: 0.13rem 0.1rem;

        .crud-item {
          margin-right: 0.04rem;
          width: 0.5rem;
          line-height: .25rem;
          color: #fff;
          // background-color: #efb227;
          background-image: url(~@/static/images/dataManagement/curd_btn.png);
          background-size: 100% 100%;
          text-align: center;
        }

        .crud-item:hover {
          cursor: pointer;
        }

        .crud-item-disabled {
          pointer-events: none;
          color: rgba(255, 255, 255, 0.6);
          // background-color: rgba(239, 178, 39, 0.6);
          opacity: 0.8;
        }

        .crud-item-disabled:hover {
          cursor: no-drop;
        }
      }
    }

    /* 矿种图标 */
    .minerals-img {
      width: 0.6rem;
      height: 0.3rem;
    }

    /* 表格样式 */
    .management-table {
      height: calc(100% - 0.5rem);

      .ant-spin-container {
        display: flex;
        flex-direction: column;
        align-items: end;
      }

      .ant-spin-nested-loading,
      .ant-spin-container,
      .ant-table-content {
        height: 100%;
      }

      .ant-table {
        height: calc(100% - .70rem);
        background: none;
        padding-left: 0.1rem;

        .ant-table-scroll {
          height: 100%;
          overflow: visible;
          overflow-x: visible;

          .ant-table-header {
            overflow: visible !important;
            margin-bottom: 0 !important;
          }
        }

        .ant-table-header {
          background: none;
        }

        .ant-table-body {
          overflow-x: hidden !important;
          overflow-y: auto !important;
          background: none;
        }

        /* 矿种 */
        .primary-commodity-img {
          width: 0.8rem;
          height: 0.6rem;
        }

        /* 图标 */
        .action-icons {
          i {
            font-size: 0.22rem;
            margin-right: 0.04rem;
            cursor: pointer;
          }
        }

        .ant-table-thead {
          border: .01rem solid #4d3f1c;
          border-radius: .10rem .10rem 0rem 0rem;
          background: none;
        }

        .ant-table-thead>tr>th {
          color: #dccdab;
          background: rgba(179, 150, 92, 0.2);
          border: none;
        }

        .ant-table-tbody>tr>td {
          background-color: transparent;
          color: #fff;
          border-bottom: .01rem solid rgba(179, 150, 92, 1);
          vertical-align: middle;
        }

        .ant-table-placeholder {
          height: 100%;
          background-color: rgba(77, 63, 28, 1);
          border-top: rgba(179, 150, 92, 1);
          border-bottom: rgba(179, 150, 92, 1);
        }

        .ant-empty-normal {
          color: rgba(179, 150, 92, 1);
        }

        // 暂无数据填充样式
        // .ant-empty-img-simple-path {
        //   fill: rgba(77, 63, 28, 1);
        // }
        // .ant-empty-img-simple-ellipse {
        //   fill: rgba(77, 63, 28, 1);
        // }
        .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
        .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-thead>tr:hover.ant-table-row-selected>td,
        .ant-table-tbody>tr:hover.ant-table-row-selected>td {
          background-color: rgba(179, 150, 92, 0.6);
        }

        .ant-table-tbody>tr.ant-table-row-selected td {
          background-color: rgba(77, 63, 28, 1);
          color: #fff;
        }
      }
    }
  }
}
</style>